import React from 'react'
import PropTypes from 'prop-types'
import CMSEntries from './CMSEntries'

CMSEntry.propTypes = {
  contentType: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  filters: PropTypes.object,
  fallbackFilters: PropTypes.object,
  renderWhenLoading: PropTypes.bool
}

export default function CMSEntry({
  contentType,
  children,
  filters,
  fallbackFilters,
  renderWhenLoading
}) {
  return (
    <CMSEntries
      contentType={contentType}
      filters={filters}
      fallbackFilters={fallbackFilters}
      renderWhenLoading={renderWhenLoading}
    >
      {entries => {
        return entries && entries[0]
          ? children(entries[0])
          : renderWhenLoading
          ? children(null)
          : null
      }}
    </CMSEntries>
  )
}
